var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcaseBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12h.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13a18.15 18.15 0 0 1-20 0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    x: 2,
    y: 6,
    rx: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseBusiness);
export default __webpack_public_path__ + "static/media/briefcase-business.5ad329eb2b2909b1b013087d4160ee46.svg";
export { ForwardRef as ReactComponent };